import { Component, OnInit, Inject } from '@angular/core';
import * as moment from 'moment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LegacyBookInitService } from 'modules/shared/legacy-bookexpress/services/legacy-book-initializer.service';
import { CurrencyService } from 'modules/shared/legacy-bookexpress/services/currency.service';
import { RGuestMessages } from 'app/model/shared/backend-api-response/rguest-messages';
@Component({
  selector: 'app-policy-modal',
  templateUrl: './policy-modal.component.html',
  styleUrls: ['./policy-modal.component.scss'],
})
export class PolicyModalComponent implements OnInit {
  public rGuestBookMessage: RGuestMessages;
  public currencyCode: any;
  public countryCode: any;
  public newRate: any;
  public propertyId: any;
  public newCurrency: any;
  public isValidCancellationDueDate: boolean = false;
  constructor(
    public appInitializer: LegacyBookInitService,
    public GetCurrencyService: CurrencyService,
    public dialogRef: MatDialogRef<PolicyModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.isValidCancellationDueDate = false;
    if (data.cancellationDueDate && data.cancellationDueDate != 'NA') {
      var date = moment(data.cancellationDueDate);
      if (date.isValid()) {
        this.isValidCancellationDueDate = true;
        if (moment(data.cancellationDueDate).isBefore(moment(this.appInitializer.configDetailsData.currentHotelDate))) {
          data.cancellationDueDate = 'NA';
          this.isValidCancellationDueDate = false;
        }
      }
    } else {
      data.cancellationDueDate = 'NA';
      this.isValidCancellationDueDate = false;
    }
  }

  ngOnInit() {
    this.propertyId = this.appInitializer.propertyId;
    this.rGuestBookMessage = this.appInitializer.PropertyData.rGuestMessages;
    this.GetCurrencyService.currentMessage.subscribe((result) => {
      if (result == 'USD') {
        this.newRate = 1;
        this.newCurrency = 'fa-usd';
      } else {
        this.newCurrency = result['fonticon'];
        this.newRate = result['currencyValue'];
        this.currencyCode = result['currencyCode'];
        this.countryCode = result['countryCode'];
      }
    });
  }

  closeModal() {
    this.dialogRef.close();
  }
}
